import { SoundConstant as SoundConstantBehavior } from "@quest/murka-games-behavior-panther/dist";

export class SoundConstantGame extends SoundConstantBehavior {
        // FREE SPIN PROGRESS SOUND EFFECTS 
        public static readonly FREE_SPIN_PROGRESS_1: string = "fs_pb_fill_1";
        public static readonly FREE_SPIN_PROGRESS_2: string = "fs_pb_fill_2";
        public static readonly FREE_SPIN_PROGRESS_3: string = "fs_pb_fill_3";
        public static readonly FREE_SPIN_PROGRESS_4: string = "fs_pb_fill_4";
        public static readonly FREE_SPIN_PROGRESS_5: string = "fs_pb_fill_5";
        public static readonly FREE_SPIN_PROGRESS_6: string = "fs_pb_fill_6";
        public static readonly FREE_SPIN_PROGRESS_7: string = "fs_pb_fill_7";

        public static readonly FREE_SPIN_PROGRESS_1_fs: string = "fs_pb_fill_on_fs_1";
        public static readonly FREE_SPIN_PROGRESS_2_fs: string = "fs_pb_fill_on_fs_2";
        public static readonly FREE_SPIN_PROGRESS_3_fs: string = "fs_pb_fill_on_fs_3";
        public static readonly FREE_SPIN_PROGRESS_4_fs: string = "fs_pb_fill_on_fs_4";
        public static readonly FREE_SPIN_PROGRESS_5_fs: string = "fs_pb_fill_on_fs_5";
        public static readonly FREE_SPIN_PROGRESS_6_fs: string = "fs_pb_fill_on_fs_6";
        public static readonly FREE_SPIN_PROGRESS_7_fs: string = "fs_pb_fill_on_fs_7";



        public static readonly SYMBOL_EXPLODE_SOUND: string = "match_3";
        public static readonly POPUP_FS_END_SOUND: string = "fs_end_popup";
        public static readonly POPUP_FS_START_SOUND: string = "fs_start_popup";
        public static readonly FS_ICON_APPEAR_SOUND: string = "fs_icon_appear";
        public static readonly BIG_WIN_SLOT: string = "big_win_slot";
        public static readonly RESPINS_START: string = "respins_start";
        public static readonly RESPINS_YOU_WON: string = "respins_you_won";
        public static readonly RESPIN_COUNT_3: string = "respin_count_3";
        public static readonly LL_ICON_WIN: string = "ll_icon_win";
        public static readonly MUSIC_RESPIN: string = "music_rs";
        public static readonly CHAR_ICON_SEPERATE: string = "character_icon_separate";
        public static readonly CHARACTER_ORC_WIN: string = "character_orc_win";
        public static readonly CHARACTER_ELF_WIN: string = "character_elf_win";
        public static readonly LL_ICON_APPEAR_SIMPLE_1: string = "ll_icon_appear_simple_1";
        public static readonly LL_ICON_APPEAR_SIMPLE_2: string = "ll_icon_appear_simple_2";
        public static readonly LL_ICON_APPEAR_MAX_1: string = "ll_icon_appear_max_1";
        public static readonly LL_ICON_APPEAR_MAX_2: string = "ll_icon_appear_max_2";
        public static readonly REVEAL_ICON_TURNING: string = "reveal_icon_turning";
        
        //respin
        public static readonly WHALE_SPAWN: string = "whale_spawn";
        public static readonly LAST_REEL_SOUND_RESPIN: string = "ll_last_icons_intrigue";

        

}
SoundConstantBehavior.VOICE_INTRO = "intro";
SoundConstantBehavior.FREE_GAME_OUTRO = "fs_end_popup";
